
import { useState, useEffect } from 'react';
import Navigation from '../../components/feature/Navigation';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import ServicesSection from './components/ServicesSection';
import ProcessSection from './components/ProcessSection';
import AboutSection from './components/AboutSection';
import PortfolioSection from './components/PortfolioSection';
import TestimonialsSection from './components/TestimonialsSection';
import PricingSection from './components/PricingSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';
import Footer from '../../components/feature/Footer';
import ScrollToTop from '../../components/feature/ScrollToTop';
import CookieConsent from '../../components/feature/CookieConsent';
import LoadingScreen from '../../components/feature/LoadingScreen';

export default function Home() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Sayfa yüklenme simülasyonu
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <LoadingScreen />
      <div className="min-h-screen bg-gray-900">
        <Navigation />
        <HeroSection />
        <FeaturesSection />
        <ServicesSection />
        <ProcessSection />
        <AboutSection />
        <PortfolioSection />
        <TestimonialsSection />
        <PricingSection />
        <FAQSection />
        <ContactSection />
        <Footer />
        <ScrollToTop />
        <CookieConsent />
      </div>
    </>
  );
}
